'use client';
import { jsxs, jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';

const PaymentMnpAsset = ({ width, height, ...props }, ref) => /* @__PURE__ */ jsxs(
  "svg",
  {
    viewBox: "0 0 84 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    width,
    height,
    ref,
    "aria-hidden": true,
    ...props,
    children: [
      /* @__PURE__ */ jsx(
        "rect",
        {
          x: 0.5,
          y: 0.5,
          width: 83,
          height: 57,
          rx: 3.5,
          fill: "white",
          stroke: "#E1E0DF"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M13.685 20.3019L13.685 20.3019C14.3748 20.2901 16.0605 20.2614 16.795 22.7433C17.3149 24.5001 18.1431 27.3779 19.2796 31.3766H19.7424C20.9612 27.1609 21.7985 24.2831 22.2542 22.7433C22.9874 20.2657 24.7546 20.29 25.6116 20.3018C25.6661 20.3025 25.717 20.3032 25.7636 20.3032L31.7806 20.3032V39.0427H25.6479V27.9992H25.2367L21.818 39.0427H17.204L13.7853 27.991H13.3741V39.0427H7.24139V20.3032L13.5878 20.3032C13.6175 20.303 13.65 20.3025 13.685 20.3019ZM40.5871 20.3032V31.3549H41.0764L45.2349 22.2672C46.0421 20.4587 47.7626 20.3032 47.7626 20.3032H53.6972V39.0427H47.4364V27.991H46.9472L42.8702 37.0788C42.063 38.8791 40.261 39.0427 40.261 39.0427H34.3264V20.3032H40.5871ZM68.6847 33.4605C71.7211 33.4605 74.4637 31.6861 75.337 29.2084H56.1655V39.0427H62.1191V33.4605H68.6847Z",
          fill: "#40A548"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M68.972 20.3033H55.8534C56.1656 24.4753 59.7542 28.0469 63.4691 28.0469H75.7507C76.4595 24.5794 74.0196 20.3033 68.972 20.3033Z",
          fill: "#1291D0"
        }
      )
    ]
  }
);
const VpPaymentMnpAsset = forwardRef(PaymentMnpAsset);

export { VpPaymentMnpAsset as default };
